import React, { useEffect, useState } from 'react';

import CasinoSliderItem from '../../../Api/Models/CasinoSliderItem';
import SiteApi from '../../../Api/SiteApi/SiteApi';
import CasinoGamesCarouselList from '../CasinoGamesList/CasinoGamesCarouselList.lazy';

export default function CasinoGamesCarouselSlidersLazy({ casinoSliderSlug }: { casinoSliderSlug: string }) {
    const [sliders, setSliders] = useState<React.JSX.Element[]>([]);

    useEffect(() => {
        SiteApi.getCasinoSliderItems(casinoSliderSlug).then((casinoSliderItems: CasinoSliderItem[]) => {
            setSliders(
                casinoSliderItems.map((casinoSliderItem: CasinoSliderItem, index: number) => (
                    <CasinoGamesCarouselList
                        key={`casino_games_carousel_list_${index}`}
                        limit={casinoSliderItem.limit}
                        casinoGameCategoryTranslationId={casinoSliderItem.casino_game_category_translation_id}
                    />
                ))
            );
        });
    }, []);

    return sliders;
}
